// @flow
import * as React from 'react';
import styled from 'styled-components';
import Button from 'components/Button';
import {
  DualAutocompleteTextInputField,
  FileUploadField,
  InputField,
  RadioButtonsField,
  CheckboxField,
  FormContextConsumer
} from 'components/Form';
import { isDefined } from 'utils/functional';
import { colors, fontWeights } from '../../theme';

const { useState } = React;

const AddButton = styled(Button)`
  padding-bottom: 31px;
  color: ${colors.waterBlue};
  font-weight: ${fontWeights.semiBold};
  &::before {
    content: '+ ';
  }
  &:hover {
    * {
      text-decoration: underline;
    }
  }
`;

const ButtonLinkGroup = ({
  namePrefix,
  alreadyOpen
}: {
  namePrefix: string,
  alreadyOpen?: boolean
}) => {
  const [open, setOpen] = useState(!!alreadyOpen);
  return (
    <FormContextConsumer>
      {({ getValue, updateValue }) => {
        if (
          isDefined(getValue(`${namePrefix}data.s3FileId`)) &&
          !isDefined(getValue(`${namePrefix}data.permission`))
        ) {
          updateValue(`${namePrefix}data.permission`, 'PUBLIC');
        }
        return open ||
          getValue(`${namePrefix}data.pageId`) ||
          getValue(`${namePrefix}data.url`) ||
          getValue(`${namePrefix}data.s3FileId`) ||
          getValue(`${namePrefix}text`) ? (
          <>
            <InputField
              name={`${namePrefix}text`}
              label={`${getText('Button Text')}`}
              description={getText('Leave empty to remove button')}
            />
            <RadioButtonsField
              name={`${namePrefix}type`}
              label={getText('Button Links To:')}
              buttons={[
                { value: 'URL', label: 'URL' },
                { value: 'CMS_PAGE', label: 'CMS Page' },
                { value: 'S3_FILE', label: 'File Upload' }
              ]}
            />
            {getValue(`${namePrefix}type`) === 'CMS_PAGE' ? (
              <DualAutocompleteTextInputField
                displayName={`${namePrefix}data.page.title`}
                valueName={`${namePrefix}data.pageId`}
                label={`${getText('Page: leave empty to remove button')}`}
                placeholder={getText('Page')}
                autocompleteType="CONTENT"
              />
            ) : getValue(`${namePrefix}type`) === 'URL' ? (
              <InputField
                description={getText('Leave empty to remove button')}
                name={`${namePrefix}data.url`}
              />
            ) : getValue(`${namePrefix}type`) === 'S3_FILE' ? (
              <>
                <FileUploadField name={`${namePrefix}data.s3FileId`} />
                <CheckboxField
                  name={`${namePrefix}data.permission`}
                  label={getText('Require login before user can download')}
                  valueToChecked={{ USER: true, PUBLIC: false }}
                />
              </>
            ) : null}
          </>
        ) : (
          <AddButton
            onClick={() => setOpen(true)}
            data-qa-id="add-button-button"
          >
            <span>{getText('Add Button')}</span>
          </AddButton>
        );
      }}
    </FormContextConsumer>
  );
};

export default ButtonLinkGroup;
